const DEMOCHAT_TOKEN = "BG42w9Ff8KNLSQKAtgWqQsyK9";

const isLocal = process.env.NODE_ENV === "development";
const configuredBaseUrl =
  process.env.REACT_APP_DEMOCHAT_BASE_URL ??
  (isLocal ? "/" : "https://demochat-dffphzayamedb7ct.westeurope-01.azurewebsites.net");

export const DEMOCHAT_BASE_URL = configuredBaseUrl.endsWith("/")
  ? configuredBaseUrl
  : `${configuredBaseUrl}/`;
export const DEMOCHAT_CHAT_URL = DEMOCHAT_BASE_URL;
export const FINISH_SESSION_URL = `${DEMOCHAT_BASE_URL}finishSession`;

export const getDemochatAuthHeaders = () => ({
  "Content-Type": "application/json; charset=utf-8",
  Authorization: `Bearer ${DEMOCHAT_TOKEN}`,
});
